export function getApiUrl(path: string): string {
    // Force relative /api path
    const cleanPath = path.startsWith('/') ? path : `/${path}`;

    if (cleanPath.startsWith('/api/')) {
        return cleanPath;
    }
    return `/api${cleanPath}`;
}
